<template>
  <v-app>
    <!-- App Bar with Navigation Icon -->
    <v-app-bar color="primary" prominent>
      <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>  
    </v-app-bar>
    
    <!-- Navigation Drawer -->
    <v-navigation-drawer v-model="drawer">
      <v-list>
        <!-- Links for Offline Users -->
        <v-list-item 
          v-for="i in oflineLinks" 
          :key="i.text" 
          :prepend-icon="i.icon" 
          :title="i.text" 
          :to="{ name: i.router }"
          v-show="!isloged"
        ></v-list-item>
        
        <!-- Links for Logged-in Users -->
        <v-list-item 
          v-show="isloged" 
          v-for="i in logedUserLinkes" 
          :key="i.text" 
          :prepend-icon="i.icon" 
          :title="i.text"
          :to="{ name: i.router }"
        ></v-list-item>

        <!-- Logout Button for Logged-in Users -->
        <v-list-item 
          v-show="isloged"
          @click="logout" 
          prepend-icon="mdi-logout" 
          title="Sair"
        ></v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Main Content Area -->
    <v-main>
      <router-view />
    </v-main>

    <!-- Footer Component -->
    <footervue></footervue>
  </v-app>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { getAuth, signOut } from 'firebase/auth';
import PagesName from './db/pagenames';
import footervue from "./views/utilitarios/footer.vue";

const pages = new PagesName();

export default defineComponent({
  name: 'App',
  components: { footervue },

  setup() {
    const store = useStore();
    const router = useRouter();
    const drawer = ref(false); // Make drawer reactive
    const isloged = computed(() => store.getters.getUserUid.isloged);
    
    const oflineLinks = [
      { icon: "mdi-store", router: pages.Homepage, text: "Explorar Plataforma" },
      { icon: "mdi-login", router: pages.login, text: "entrar como ADM" },
      { icon: "mdi-account-tie", router: pages.criarconta, text: "Criar conta como ADM" },
    ];
    
    const logedUserLinkes = [
      { icon: "mdi-store", router: pages.Homepage, text: "Explorar Plataforma" },
      { icon: "mdi-view-dashboard", router: pages.dashboardPage, text: "Painel ADMIN" },
    ];

    // Logout function
    const logout = async () => {
      const auth = getAuth();
      try {
        await signOut(auth);
        store.commit('SET_USER', null);  // Clear user info in the store
        router.push({ name: pages.login }); // Redirect to login
      } catch (error) {
        console.error("Erro ao sair:", error);
      }
    };

    return { oflineLinks, isloged, logedUserLinkes, drawer, logout };
  }
});
</script>
